module.exports = __webpack_public_path__ + "img/car6.6784678e.png";